import { useState } from 'react';
import './styles.scss';

export const TabSelect = ({ options = [], getTab }) => {
  const [selectedTab, setSelectedTab] = useState(options[0]?.value);

  const handleChangeTab = (value) => {
    setSelectedTab(value);
    getTab(value);
  }

  return <div className='tab-select__container'>
    {
      options.map(option => (
        <div
          key={option.value}
          className={`tab-select__content ${option?.value == selectedTab ? 'active' : ''}`}
          onClick={() => handleChangeTab(option?.value)}
        >
          <small>{option?.label}</small>
        </div>    
      ))
    }
  </div>
}